/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Field Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 08:38:43 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FIELD_LIST_CONTAINER_LOADED = 'FIELD_LIST_CONTAINER_LOADED';
export const FIELD_LIST_CONTAINER_UNLOADED = 'FIELD_LIST_CONTAINER_UNLOADED';
export const FIELD_LIST_TABLE_LOADED = 'FIELD_LIST_TABLE_LOADED';
export const FIELD_LIST_TABLE_UNLOADED = 'FIELD_LIST_TABLE_UNLOADED';

export const FIELD_LIST_CHANGE_GROUP_SELECT = 'FIELD_LIST_CHANGE_GROUP_SELECT';
export const FIELD_LIST_CHANGE_SET_SELECT = 'FIELD_LIST_CHANGE_SET_SELECT';
export const FIELD_SELECT_ROW = 'FIELD_SELECT_ROW';

export const FIELD_ADD = 'FIELD_ADD';
export const FIELD_EDIT = 'FIELD_EDIT';
export const FIELD_DELETE = 'FIELD_DELETE';
export const FIELD_OPEN_WARNING = 'FIELD_OPEN_WARNING';
export const FIELD_CLOSE_WARNING = 'FIELD_CLOSE_WARNING';
export const FIELD_DELETE_DISABLE = 'FIELD_DELETE_DISABLE';
export const FIELD_VIEW_CHILD_ITEMS = 'FIELD_VIEW_CHILD_ITEMS';

export const FIELD_EDIT_CONTAINER_LOADED = 'FIELD_EDIT_CONTAINER_LOADED';
export const FIELD_EDIT_CONTAINER_UNLOADED = 'FIELD_EDIT_CONTAINER_UNLOADED';
export const FIELD_EDIT_FORM_LOADED = 'FIELD_EDIT_FORM_LOADED';
export const FIELD_EDIT_FORM_UNLOADED = 'FIELD_EDIT_FORM_UNLOADED';

export const FIELD_EDIT_DATA_LOAD = 'FIELD_EDIT_DATA_LOAD';
export const FIELD_SET_PATHTRAIL = 'FIELD_SET_PATHTRAIL';

export const FIELD_EDIT_CONTAINER_SUBMIT = 'FIELD_EDIT_CONTAINER_SUBMIT';
export const FIELD_EDIT_CONTAINER_CANCEL = 'FIELD_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeFields.js